import prettyms from "pretty-ms"
import filesize from "filesize"

let buildstats = {}

window.fetch("stats.json").then((response) => response.json()).then((response) => {
    buildstats.data = response
    buildstats.time = "???"
    // buildstats.time = prettyms(buildstats.data.time)
    buildstats.size = buildstats.data.assets.reduce((size, asset) => size + asset.size, 0)
    // buildstats.size = buildstats.data.assets.find((asset) => asset.name == "index.js").size
    // buildstats.size = buildstats.data.assets.filter((asset) => asset.name.endsWith(".js")).reduce((size, asset) => size + asset.size, 0)
    buildstats.size = filesize(buildstats.size, {"spacer": ""})
})

window.frog = window.frog || {}
window.frog.buildstats = buildstats

export default buildstats
